import React, {useEffect, useState} from 'react';
import axios from 'axios';
import classes from './LegalDisclaimer.module.scss';
import ReactGa from "react-ga";
import {Helmet} from "react-helmet";
import HomeBreadcrumbHook from "../../components/UI/HomeButton/HomeBreadcrumbHook";
import scrollToComponent from "react-scroll-to-component";
import {FormattedMessage} from "react-intl";
import {LANG_EN, LANG_ID} from "../../constants";

const LegalDisclaimerHook = (props) => {
    const [state, setState] = useState({
        done: false
        , disclaimer: []
        , disclaimer_indo: []
    });

    useEffect(() => {
        //add by hendra on 14 oct 2020
        ReactGa.pageview(window.location.origin.toString() + props.location.pathname);
        window.scrollTo(0, 0);

        const fetchData = async () => {
            const header = {headers: {'language': LANG_EN}};
            const getData = await axios.get('static/disclaimer', header); //ini dis

            const headerId = {headers: {'language': LANG_ID}};
            const getData_id = await axios.get('static/disclaimer', headerId);
            setState({
                done: true
                , disclaimer: getData.data
                , disclaimer_indo: getData_id.data
            })
        }
        fetchData().catch(e => (e.message));
    }, [props.location.pathname]);

    let tempMetaDesc;
    let metaDesc;
    if (state.disclaimer.content !== undefined) {
        tempMetaDesc = state.disclaimer.content.replace(/(<([^>]+)>)/ig, "");
        metaDesc = tempMetaDesc.length > 150 ? tempMetaDesc.substr(0, 150).trim() : tempMetaDesc.trim();
    }

    return (
        <>
            <div className={["violet", classes.LegalDisclaimer_container].join(' ')} ref={(section) => {
                scrollToComponent.Violet = section;}}>
                <Helmet>
                    <meta name="description"
                          content={"JAPFA FOOD: ".concat(metaDesc)}/>
                    <meta name="keywords"
                          content="Japfa Indonesia, food service, frozen food, supplier frozen food, Best Chicken, Tokusen, Omayo, Greenfields, so good, food catering, food service delivery, meat shop, Chicken shop, food solutions, JBFS, Food Supplier"/>
                    <meta name="author" content=""/>
                    <meta property="og:title" content="Terms and Conditions Japfa Food | Indonesia | Food Supplier"/>
                    <meta property="og:description"
                          content={"JAPFA FOOD: ".concat(metaDesc)}/>
                    <title>{"Terms and Conditions Japfa Food | Indonesia | Food Supplier"}</title>
                    <link rel="canonical" href={window.location.origin.toString() + props.location.pathname}/>
                </Helmet>
                {/*Bread crumbs region*/}
                <section className={[classes.LegalDisclaimer_sectionBread].join(' ')}>
                    <div className={["jbfs-wrapper", classes.LegalDisclaimer_wrapperBread].join(' ')}>
                        <div className={["jbfs-breadcrumb-row",].join(' ')}>
                            <HomeBreadcrumbHook/>
                            <span>/</span>
                            <div><FormattedMessage id={"legalpage.title"} defaultMessage={"Terms and Conditions"}/></div>
                        </div>
                    </div>
                </section>
                {/*Bread crumbs region*/}

                <section className={classes.LegalDisclaimer_sectionHeader}>
                    <div className={["jbfs-wrapper", classes.LegalDisclaimer_wrapperHeader].join(' ')}>
                        <div>
                            <h1><FormattedMessage id={"legalpage.title"} defaultMessage={"Terms and Conditions"}/></h1>
                        </div>
                    </div>
                </section>

                <section className={classes.LegalDisclaimer_sectionContent}>
                    <div className={["jbfs-wrapper", classes.LegalDisclaimer_wrapperContent].join(' ')}>
                        <div className={classes.LegalDisclaimer_contentCard}>
                            <p className={classes.Content} dangerouslySetInnerHTML={{__html: state.disclaimer.content}}/>
                            <hr/>
                            <p className={classes.Content} dangerouslySetInnerHTML={{__html: state.disclaimer_indo.content}}/>
                        </div>
                    </div>
                </section>

            </div>
        </>
    )
}

export default LegalDisclaimerHook